import Swal from 'sweetalert2'
// import './styles.css'

export async function Ask(title, fnSuccess) {
  return Swal.fire({
    title,
    showCancelButton: true,
    confirmButtonText: 'Sim',
    cancelButtonText: 'Não',
    confirmButtonColor: '#0d6efd',
    cancelButtonColor: '#d33',
  }).then((result) => {
    if (result.isConfirmed) {
      fnSuccess()
    }
  })
}
